import React from 'react';
import { Box } from '@mui/material';

interface LoadingSpinnerProps {
  size?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 60
}) => {
  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center"
      sx={{ width: size, height: size }}
    >
      <Box
        component="img"
        src="/logo-animated.svg"
        alt="Loading..."
        sx={{
          width: size,
          height: size,
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

export default LoadingSpinner;